<template>
  <div>
    <span class="badge badge-warning" v-if="chargeType == 'FreightAdjustment'">Accessorial Surcharges</span>
    <!-- <span class="badge badge-warning" v-else-if="chargeType == 'FreightAdjustmentEstimate'">Freight Adjustment - Estimate</span>
    <span class="badge badge-info" v-else-if="chargeType == 'FreightChargesEstimate'">Freight Charge - Estimate</span>
    <span class="badge badge-info" v-else-if="chargeType == 'FreightCharges'">Freight Charge</span> -->

    <span class="badge badge-primary" v-else-if="chargeType == 'TPLHandling'">WMS - Handling</span>
    <span class="badge badge-primary" v-else-if="chargeType == 'TPLStorage'">WMS - Storage</span>
    <span class="badge badge-primary" v-else-if="chargeType == 'TPLPrepaidFreight'">WMS - Prepaid Freight</span>
    <span class="badge badge-primary" v-else-if="chargeType == 'TPLThirdPartyFreight'">WMS - Third Party Freight</span>
    <span class="badge badge-primary" v-else-if="chargeType == 'TPLSpecialCharges'">WMS - Special Charges</span>
    <span class="badge badge-primary" v-else-if="chargeType == 'TPLMaterials'">WMS - Materials</span>
    <span class="badge badge-primary" v-else-if="chargeType == 'TPLAutoCalcStorage'">WMS - AutoCalc Storage</span>
    <span class="badge badge-primary" v-else-if="chargeType == 'TPLAutoCalcHandling'">WMS - AutoCalc Handling</span>

    <span class="badge badge-info" v-else-if="chargeType == 'BulkShipmentFreight'">Bulk Transportation</span>

    <span class="badge badge-info" v-else-if="chargeType == 'ConnectOrderReturn'">Order Return</span>
    <span class="badge badge-info" v-else-if="chargeType == 'ConnectOrderItemReturn'">Order Item Returned</span>

    <span class="badge badge-danger" v-else-if="chargeType == 'ConnectFreightCharge'">Connect Freight Charge</span>
    <span class="badge badge-danger" v-else-if="chargeType == 'ConnectFreightFuelSurchargeCharge'">Connect Fuel Surcharge</span>

    <span class="badge badge-danger" v-else-if="chargeType == 'ConnectAutoCalcStorage'">Connect AutoCalc Storage</span>
    <span class="badge badge-danger" v-else-if="chargeType == 'ConnectAutoCalcPickBin'">Connect AutoCalc Pick Bin</span>

    <span class="badge badge-secondary" v-else-if="chargeType == 'ConnectAdministrative'">Administrative</span>
    <span class="badge badge-success" v-else-if="chargeType == 'ConnectFulfillmentCharge'">Fulfillment Fee</span>
    <span class="badge badge-secondary" v-else>Other Charge</span>
  </div>
</template>

<script>
export default {
  props: {
    chargeType: {
      required: true
    }
  }
}
</script>

<style>

</style>
